// Chart specs in agent answers are written by the model, so their text can carry
// injected markup. Plotly renders a small HTML subset in titles, axis labels,
// legend names and tick labels, including clickable <a href> links. Escaping
// turns any tag into literal text; Plotly decodes the entities back for display.

export function plotSafeText(value: unknown): string {
  if (value === null || value === undefined) return '';
  return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

/** Escape string entries (category labels); leave numbers and dates as they are. */
export function plotSafeValues(values: unknown): unknown {
  if (!Array.isArray(values)) return values;
  return values.map((v) => (typeof v === 'string' ? plotSafeText(v) : v));
}
